import http from "@/plugins/http";

export const getNoticeList = (data) => {
  return http.get(`/jeecg-boot/webapi/announcement/announcementManage/list`, {
    params: data,
  });
};
export const getDashboardsNoticeList = (data) => {
  return http.get(
    `/jeecg-boot/webapi/announcement/announcementManage/currentlyValidList`,
    {
      params: data,
    }
  );
};
export const getNoticeDetail = (data) => {
  return http.get(
    `/jeecg-boot/webapi/announcement/announcementManage/queryById`,
    { params: data }
  );
};
